import React from 'react';
import cn from 'clsx';

import { Switch } from '@headlessui/react';

export type ToggleProps = {
  activeClassName?: string;
  onChange: (data: boolean) => void;
  onBlur?: () => void;
  value?: boolean;
  disabled?: boolean;
};

const Toggle = React.forwardRef<HTMLDivElement, ToggleProps>(
  function SwitchWithRef(
    { onChange, onBlur, value, activeClassName = 'bg-green', disabled },
    ref
  ) {
    return (
      <div ref={ref}>
        <Switch
          disabled={disabled}
          checked={value || false}
          onChange={onChange}
          onBlur={onBlur}
          className={cn(
            'relative inline-flex items-center h-6 rounded-full w-11 focus:outline-none',
            {
              [activeClassName]: value,
              'bg-gray-dark': !value,
              'cursor-not-allowed': disabled,
            }
          )}
        >
          <span
            style={{ height: '1rem' }}
            className={cn(
              'inline-block w-4 h-4 transform bg-white rounded-full',
              {
                'translate-x-6': value,
                'translate-x-1': !value,
              }
            )}
          />
        </Switch>
      </div>
    );
  }
);

export default Toggle;
